import { render } from "./ModalActionConfirmation.vue?vue&type=template&id=01ce6bf1"
import script from "./ModalActionConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalActionConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__